module.exports = __webpack_public_path__ + "static/media/star_unchecked.4d14ef73.svg";